import API_URLS from '@mgCommon/constants/api-urls.js';
import axiosRestInstance from '@mgCommon/http/axios-rest-client.js';
import { getCbBaseURL, getCbVarible } from '@mgCommon/utils/utils.js';

function restClientInstance() {
  const baseURL = getCbBaseURL();
  return axiosRestInstance({ baseURL });
}

function config(queryParams = {}) {
  const token = getCbVarible();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    params: queryParams,
    data: {},
  };
}

class InterstitialService {
  sendInterstitial({ recipients = [], inArguments = {} } = {}) {
    const data = {
      recipients,
      inArguments,
    };
    return restClientInstance().post(API_URLS.SEND_INTERSTITIAL, data, config());
  }
}

export default new InterstitialService();
